define('fukit/behavior/show.modal.on.modal.hide.with.unsaved.changes.behavior',['require','exports','module','underscore','marionette','backbone','../model/base.model','backbone.radio','../view/block/unsaved.changes.modal.view'],function(require, exports, module) {
  //prettier-ignore
  var _                       = require('underscore'),
      Mn                      = require('marionette'),
      Backbone                = require('backbone'),
      BaseModel               = require('../model/base.model'),
      Radio                   = require('backbone.radio'),
      UnsavedChangesModalView = require('../view/block/unsaved.changes.modal.view');

  var ShowModalOnModalHideWithUnsavedChangesBehavior = Mn.Behavior.extend({
    onFirstRender: function() {
      this.listenTo(Radio.request('modals', 'lastInitialized'), 'modal:hidden', function(modalView, options) {
        var model = this.getModel();

        if (_.result(options, 'denyWasPressed') || !(model instanceof BaseModel) || !model.hasUnsavedChanges()) {
          this.checkFetchModelOnDeny(modalView);
          return;
        }

        // option to be picked up by anything that might
        // try to destroy the view on hidden
        options.resistDestroy = true;

        var unsavedChangesModalView = this.createUnsavedChangesModal()
          .on(
            'confirm',
            function() {
              Mn.triggerMethodOn(modalView, 'unsavedChangesModal:confirm', modalView, {
                model: model,
                unsavedChangesModalView: unsavedChangesModalView,
              });
              return new Promise(function(resolve, reject) {
                model.save(null, {
                  success: resolve,
                  error: reject,
                });
              })
                .bind(this)
                .tap(function(resp) {
                  // the model did save correctly
                  if (modalView.getOption('destroyOnHidden')) {
                    modalView.destroy();
                  }
                })
                .catch(function(e) {
                  // the model did not save correctly
                  // so show the original modal view again
                  modalView.visible = true;
                  throw e;
                });
            },
            this
          )
          .on(
            'deny',
            function() {
              Mn.triggerMethodOn(modalView, 'unsavedChangesModal:deny', modalView, {
                model: model,
                unsavedChangesModalView: unsavedChangesModalView,
              });

              this.checkFetchModelOnDeny(modalView);

              if (modalView.getOption('destroyOnHidden')) {
                modalView.destroy();
              }
            },
            this
          )
          .on('modal:hidden', function(self, options) {
            var didSelectModalOption = _.result(options, 'denyWasPressed') || _.result(options, 'confirmWasPressed');
            if (!didSelectModalOption) {
              modalView.visible = true;
            }
          });
      });
    },

    createUnsavedChangesModal: function(options) {
      if (this.view.buildComponent) {
        return this.view.buildComponent(_.extend({ type: UnsavedChangesModalView, visible: true }, options));
      }
    },

    getModel: function() {
      return this.getOption('model') || this.view.getOption('model');
    },

    checkFetchModelOnDeny: function(modalView) {
      var fetchModel = modalView ? modalView.getOption('fetchModelOnDeny') : false;

      if (fetchModel === true) {
        fetchModel = this.getModel();
      }

      if (fetchModel instanceof Backbone.Model) {
        fetchModel.fetch();
      }
    },
  });

  module.exports = ShowModalOnModalHideWithUnsavedChangesBehavior;
});

